<script setup>
import axios from 'axios'
import { Lock } from 'lucide-vue-next'

const { user, setupToken } = useLocalStorage()
const notification = useNotification()
const { t } = useI18n()

const router = useRouter()
const route = useRoute()
const isOpen = ref(false)
const isSettingsPanelOpen = ref(false)
const password = ref('')
const confirmPassword = ref('')

watch(route, (to) => {
  // Close sidebar on route change
  isSettingsPanelOpen.value = false
  isOpen.value = false
  checkOnboarding(to.name)
})

onMounted(() => {
  checkOnboarding(route.name)
})

const checkOnboarding = (route) => {
  if (route !== 'Setup' && setupToken.value) {
    router.push({ name: 'Setup' })
  }
}

const emit = defineEmits(['passwordChanged'])

const submitPassword = (e) => {
  e.preventDefault()
  if (password.value.length < 8) {
    notification.create('error', {
      text: t('login.reset.error.password_length'),
      timeout: 2000
    })
    return
  } else if (password.value !== confirmPassword.value) {
    notification.create('error', {
      text: t('login.reset.error.confirm_password_different'),
      timeout: 2000
    })
    return
  }

  axios
    .patch(`/users/${user.value.id}/change-password`, {
      password: password.value
    })
    .then((response) => {
      user.value = {
        ...user.value,
        ...response.data.data
      }
      user.value.hasToChangePassword = false
      notification.create('success', {
        text: t('login.changePassword.success'),
        persist: true
      })
      emit('passwordChanged')
      return
    })
    .catch(() => {
      notification.create('error', {
        text: t('login.changePassword.error'),
        timeout: 2000
      })
      return
    })
}
</script>

<template>
  <form action="#" method="POST">
    <div>
      <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
        <Lock class="h-6 w-6 text-green-600" />
      </div>
      <div class="mt-2 text-center">
        <h3 class="text-lg font-medium leading-6 text-foreground">
          {{ t('login.changePassword.title') }}
        </h3>
        <div class="mt-2">
          <p class="text-sm text-muted-foreground">
            {{ t('login.changePassword.description') }}
          </p>
        </div>

        <div class="mt-6">
          <Input
            id="password"
            v-model="password"
            type="password"
            autocomplete="current-password"
            :placeholder="t('login.reset.newPassword')"
            required
          />
        </div>

        <div class="mt-2">
          <Input
            id="confirmPassword"
            v-model="confirmPassword"
            type="password"
            autocomplete="current-password"
            :placeholder="t('login.reset.confirmNewPassword')"
            required
          />
        </div>
      </div>
    </div>
    <div class="mt-6">
      <Button type="submit" variant="default-primary" class="w-full" @click="submitPassword">
        {{ t('login.changePassword.button.submit') }}
      </Button>
    </div>
  </form>
</template>
